module.exports = __webpack_public_path__ + "images/corners/Cathedral.3a6a108457faf99580ee4774bef43e96.jpg";